import { Injectable } from '@angular/core';
import { FormFactory } from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { OrganizationUpdateOptions } from '../../../../../../../../common/src/options/organization-update.options';

@Injectable()
export class OrganizationUpdateFormFactory {

  constructor(
    private readonly formFactory: FormFactory) {
  }

  create(): AdvancedForm<OrganizationUpdateOptions> {
    return this.formFactory.create(new OrganizationUpdateOptions(), [
      // new AdvancedFormButton('SAVE', ButtonStyleEnum.Primary, "Sauvegarder", ButtonTypeEnum.Submit),
    ]);
  }
}
